<div>
	<div class="menu-trigger-button" [matMenuTriggerFor]="menu">
		<span>{{ 'mes.administration.terminal.menu.label' | translate }}</span>
	</div>
	<mat-menu #menu="matMenu">
		<button mat-menu-item [matMenuTriggerFor]="printMenu" [disabled]="!items.length">
			{{ 'mes.administration.terminal.menu.print.label' | translate }}
		</button>

		<span mat-menu-item>{{ 'mes.administration.terminal.menu.instructions' | translate }}</span>
		<span mat-menu-item (click)="toggleShowHideNonReady()">
			<mat-icon [svgIcon]="showNonReady ? 'acies_check' : 'acies_uncheck'"></mat-icon>
			{{ 'mes.administration.terminal.menu.toggle-show-non-ready-items' | translate }}
		</span>
		<span *appHasPermission="'docs:TemplateCreate'" mat-menu-item (click)="copyItemData()">
			{{ 'mes.administration.terminal.menu.copy-item-data' | translate }}
		</span>
		<span *appHasPermission="'docs:TemplateCreate'" mat-menu-item (click)="copyGroupData()">
			{{ 'mes.administration.terminal.menu.copy-group-data' | translate }}
		</span>
	</mat-menu>

	<mat-menu #printMenu="matMenu">
		@for (config of items; track config.name) {
			<button mat-menu-item (click)="startPrint(config)">({{ config.name }}) {{ config.description }}</button>
		}
	</mat-menu>
</div>
